<template>
    <BaseWidget
        :id="id"
        :widget-name="widgetName"
        :has-content="!!content"
        :is-loading="isLoading"
        :is-expanded="isExpanded"
        :configuration-data="configurationData"
        :widget-type="widgetType"
        :widget-last-updated="widgetLastUpdated"
        :needs-attention="needsAttention"
        v-on="$listeners"
    >
        <div v-show="!isLoading" class="widget-content widget-scrollable recent-event">
            <div class="widget-inner">
                <div class="widget-table-wrapper">
                    <Component
                        :is="isPrintver ? 'div' : 'Simplebar'"
                        :class="isPrintver ? '' : 'with-border-track'"
                    >
                        <table class="recent-table">
                            <thead>
                                <tr>
                                    <th>{{ $t('reporting.commonLabels.callType') }}</th>
                                    <th>{{ $t('common.location') }}</th>
                                    <th>{{ $t('dashboard.labels.duration') }}</th>
                                    <th>{{ $t('reporting.commonLabels.startTimeDate') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(call, index) in content" :key="index">
                                    <td>
                                        <div
                                            class="call-type with-tooltip"
                                            :data-tooltip="getCallTypeName(call.category, call)"
                                        >
                                            {{ getCallTypeName(call.category) }}
                                            <span>
                                                <i
                                                    :class="
                                                        'icon-' +
                                                            getCallTypeName(
                                                                call.category,
                                                                call
                                                            ).toLocaleLowerCase()
                                                    "
                                                ></i>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="location">{{ call.location }}</div>
                                    </td>
                                    <td class="duration" :class="getCallDurationClass(call)">
                                        {{ getCallDuration(call) }}
                                    </td>
                                    <td>
                                        <div class="date">{{ call.st_date }}</div>
                                        <div class="date">{{ call.st_time }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Component>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script type="text/babel">
import { mapState, mapGetters } from 'vuex';
import Simplebar from 'simplebar-vue';
import BaseWidget from '../BaseWidget';
import { durations, getTranslationKeyByOption, getCallTypeNameById } from '../widgetHelpers';
import widgetInterface from './common/widgetInterface';
import WidgetConfigurationTable from './common/WidgetConfigurationTable.vue';
import { configurationData } from './common/widgetsComputedProps';

export default {
    components: {
        BaseWidget,
        WidgetConfigurationTable,
        Simplebar,
    },

    props: widgetInterface,

    data() {
        return {
            needsAttention: false,
        };
    },

    computed: {
        ...mapGetters('user', ['userType']),
        ...mapState({
            navCollapsed: 'navCollapsed',
            callTypes: 'callTypes',
            allAssignmentAreas: 'assignmentArea',
        }),

        configurationData,

        /**
         * Returns widget name
         * @returns {string}
         */
        widgetName() {
            return this.configuration.name || this.$t('dashboard.widgetType5.name');
        },

        /**
         * Returns translated name of selected duration
         * @returns {string}
         */
        duration() {
            return this.$t(getTranslationKeyByOption(durations, this.configuration.duration));
        },
    },

    methods: {
        /**
         * Gets call type name by its ID
         * @param {number} callTypeId
         * @returns {string}
         */
        getCallTypeName(callTypeId) {
            return getCallTypeNameById(this.callTypes, callTypeId);
        },

        /**
         * Returns call duration or "ongoing" or "incomplete"
         * @param {Object} call
         * @returns {string}
         */
        getCallDuration(call) {
            if (call.incomplete) {
                return this.$t('dashboard.widgetType5.incomplete');
            }

            return call.duration !== null ? call.duration : this.$t('dashboard.widgetType5.ongoing');
        },

        /**
         * Gets call duration CSS class
         * @param {Object} call
         * @returns {string}
         */
        getCallDurationClass(call) {
            if (call.incomplete) {
                return '';
            }

            return call.duration === null ? 'ongoing' : call.target;
        },

        setNeedsAttention(value) {
            this.needsAttention = value;
        },
    },
};
</script>
